import {useMutation} from "react-query";
import folderService from "../../services/FolderService";

export default function useGetFolderByCode() {
   return useMutation((code: string) => folderService.findByCode(code));
}